import PropTypes from 'prop-types';
import React from 'react';
import omit from 'lodash/omit';
import ReactDOM from 'react-dom';
import * as Colors from 'constants/Colors';
import ModalHeaderWithClose from './ModalHeaderWithClose';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.node = document.createElement('div');
    Object.assign(this.node.style, {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 10,
      backgroundColor: Colors.COLOR__WHITE_100,
      transform: `translate(0px, ${window.innerHeight}px)`,
      webkitTransform: `translate(0px, ${window.innerHeight}px)`,
      transition:
        'transform 0.2s cubic-bezier(0.860, 0.000, 0.070, 1.000), -webkit-transform 0.2s cubic-bezier(0.860, 0.000, 0.070, 1.000)',
    });
  }

  componentDidMount() {
    this.props.isOpen && this._open();
  }

  componentWillUnmount() {
    if (this.props.isOpen) {
      this._close();
    }
  }

  componentDidUpdate(prev) {
    if (prev.isOpen === this.props.isOpen) return null;
    this.props.isOpen ? this._open() : this._close();
  }

  open() {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(
        'Modal no longer supports imperative style, use isOpen prop instead.'
      );
    }
  }

  _open() {
    this.props.onOpen && this.props.onOpen();
    document.body.appendChild(this.node);
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      Object.assign(this.node.style, {
        webkitTransform: `translate(0px, 0px)`,
        transform: `translate(0px, 0px)`,
      });
    });
  }

  _close() {
    this.props.onClose && this.props.onClose();
    document.body.style.overflow = null;
    document.documentElement.style.overflow = null;
    Object.assign(this.node.style, {
      webkitTransform: `translate(0px, ${window.innerHeight}px)`,
      transform: `translate(0px, ${window.innerHeight}px)`,
    });
    const onTransitionEnd = () => {
      const body = document.body;
      body.contains(this.node) && body.removeChild(this.node);
      this.node.removeEventListener('transitionend', onTransitionEnd);
    };

    this.node.addEventListener('transitionend', onTransitionEnd);
  }

  handleCloseClick = event => {
    this.props.onRequestModalClose(event);
  };

  render() {
    if (!this.props.isOpen) return null;
    const {icon, header, ...rest} = this.props;
    const content = (
      <div
        style={{
          maxHeight: '100%',
          height: '100%',
          overflow: 'scroll',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {header ? (
          <ModalHeaderWithClose
            onClose={this.props.onRequestModalClose}
            icon={icon}
          >
            {header}
          </ModalHeaderWithClose>
        ) : null}
        <div
          {...omit(rest, [
            'onRequestModalClose',
            'isOpen',
            'onOpen',
            'onClose',
          ])}
        />
      </div>
    );
    return ReactDOM.createPortal(content, this.node);
  }
}

Modal.propTypes = {
  header: props =>
    props.header
      ? new Error(
          '`header` in `Modal` is deprecated. Please provide a header in children. For default behavior, use ModalHeaderWithClose.'
        )
      : null,
  icon: PropTypes.node,
};

Modal.defaultProps = {
  isOpen: false,
};

export default Modal;
